<template>
  <div class="home page">
    <p class="text-center text-danger">Er staat geen woningselector geregistreerd op dit domein!</p>
  </div>
</template>

<script>
    import Filters from '../components/Filters.vue'
    import Selector from '../components/Selector.vue'

    export default {
      name: 'home',
      components: {
          Filters,
          Selector
      },
      mounted() {
        if(process.env.VUE_APP_ENV !== 'production') {
          window.location.href = '/fa005713'
        }
      }
    }
</script>
